import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { RecruiterWorkspace } from '@nest-recruit/shared';
import { apiGet, type ApiError } from '../../../lib/api-client';

export const WORKSPACE_KEY = ['workspace'] as const;

/**
 * The workspace gathers seven other modules' records, so no single realtime hint names it.
 * It refreshes each minute and whenever the tab comes back into view, never blanking what is
 * on screen while it does (§5a rule 2).
 */
const REFRESH_MS = 60_000;

export function useWorkspace(isEnabled: boolean): UseQueryResult<RecruiterWorkspace, ApiError> {
  return useQuery({
    queryKey: WORKSPACE_KEY,
    queryFn: () => apiGet<RecruiterWorkspace>('/workspace'),
    enabled: isEnabled,
    placeholderData: (previous) => previous,
    refetchInterval: REFRESH_MS,
  });
}
